
import { useState } from "react"
import { Plus } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"

interface CategoryFormNewProps {
  onSubmit: (name: string, description: string) => Promise<void>
}

export function CategoryFormNew({ onSubmit }: CategoryFormNewProps) {
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")

  const handleSubmit = async () => {
    await onSubmit(name, description)
    setName("")
    setDescription("")
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Add New Category</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="categoryName">Category Name</Label>
            <Input
              id="categoryName"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="categoryDescription">Description (Optional)</Label>
            <Input
              id="categoryDescription"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <Button onClick={handleSubmit}>
          <Plus className="mr-2 h-4 w-4" />
          Add Category
        </Button>
      </CardContent>
    </Card>
  )
}
